
export interface InterfaceMonitoringEntity {
    //message type = CCGLIN
    id: number,
    interfaceMonitorHdrId?: number | null,
    messageType: string,
    status?: string | null,
    sendReceiveDate?: Date | null,
    from: string,
    to: string,
    message?: string | null,
    batchName?: string | null,
    filename?: string | null,
    setOfBooksId?: string | null,
    accountingDate?: string | null,
    currencyCode?: string | null,
    dateCreated?: string | null,
    createdBy?: string | null,
    actualFlag?: string | null,
    statusCCGLine?: string | null,
    createdByCCGLine?: string | null,
    userJeCategoryName?: string | null,
    userJeSourceName?: string | null,
    currencyConversionDate?: string | null,
    userCurrencyConversionType?: string | null,
    currencyConversionRate?: string | null,
    enteredDr?: string | null,
    enteredCr?: string | null,
    accountedDr?: string | null,
    accountedCr?: string | null,
    reference1?: string | null,
    reference2?: string | null,
    reference4?: string | null,
    reference5?: string | null,
    reference6?: string | null,
    reference7?: string | null,
    reference8?: string | null,
    reference10?: string | null,
    segment1Pk?: string | null,
    segment2Pk?: string | null,
    segment3Pk?: string | null,
    segment4Pk?: string | null,
    segment5Pk?: string | null,
    segment6Pk?: string | null,
    segment7Pk?: string | null,
    segment8Pk?: string | null,
    segment9Pk?: string | null,
    periodName?: string | null,
    budgetVersionId?: string | null,
    attribute1?: string | null,
    attribute2?: string | null,
    attribute3?: string | null,
    attribute4?: string | null,
    attribute5?: string | null,
    attribute6?: string | null,
    attribute7?: string | null,
    attribute8?: string | null,
    attribute9?: string | null,
    attribute10?: string | null,
    context?: string | null,
    //message type = SLARRE
    shippingLine?: string | null,
    invoiceNo?: string | null,
    invoiceDate?: string | null,
    invoiceAmount?: string | null,
    creditNoteNo?: string | null,
    creditNoteDate?: string | null,
    creditNoteAmount?: string | null,
    receiptChequeNo?: string | null,
    receiptChequeDate?: string | null,
    receiptChequeAmount?: string | null,
    taxChallenNo?: string | null,
    taxChallenDate?: string | null,
    taxChallenAmount?: string | null,
    balanceAmount?: string | null,
    remarks?: string | null,
    //message type = SLARDS
    interfaceDistributionId?: string | null,
    interfaceLineId?: string | null,
    interfaceLineContext?: string | null,
    interfaceLineAttribute1?: string | null,
    interfaceLineAttribute2?: string | null,
    interfaceLineAttribute3?: string | null,
    interfaceLineAttribute4?: string | null,
    interfaceLineAttribute5?: string | null,
    interfaceLineAttribute6?: string | null,
    interfaceLineAttribute7?: string | null,
    interfaceLineAttribute8?: string | null,
    accountClass?: string | null,
    amount?: string | null,
    percent?: string | null,
    segment1?: string | null,
    segment2?: string | null,
    segment3?: string | null,
    segment4?: string | null,
    segment5?: string | null,
    segment6?: string | null,
    segment7?: string | null,
    segment8?: string | null,
    segment9?: string | null,
    docCreatedBy?: string | null,
    docCreationDate?: string | null,
    docLastUpdatedBy?: string | null,
    docLastUpdateDate?: string | null,
    orgId?: string | null,
    attributeCategory?: string | null,
    //message type = SLARLN
    batchSourceName?: string | null,
    lineType?: string | null,
    description?: string | null,
    custTrxTypeName?: string | null,
    termName?: string | null,
    origSystemBillCustomerRef?: string | null,
    origSystemBillAddressRef?: string | null,
    origSystemBillContactRef?: string | null,
    origSystemShipCustomerRef?: string | null,
    origSystemShipAddressRef?: string | null,
    origSystemShipContactRef?: string | null,
    origSystemSoldCustomerRef?: string | null,
    linkToLineContext?: string | null,
    linkToLineAttribute1?: string | null,
    linkToLineAttribute2?: string | null,
    linkToLineAttribute3?: string | null,
    linkToLineAttribute4?: string | null,
    linkToLineAttribute5?: string | null,
    linkToLineAttribute6?: string | null,
    linkToLineAttribute7?: string | null,
    receiptMethodName?: string | null,
    conversionType?: string | null,
    conversionDate?: string | null,
    conversionRate?: string | null,
    trxDate?: string | null,
    glDate?: string | null,
    documentNumber?: string | null,
    trxNumber?: string | null,
    lineNumber?: string | null,
    quantityOrdered?: string | null,
    unitSellingPrice?: string | null,
    referenceLineContext?: string | null,
    referenceLineAttribute1?: string | null,
    referenceLineAttribute2?: string | null,
    referenceLineAttribute3?: string | null,
    referenceLineAttribute4?: string | null,
    referenceLineAttribute5?: string | null,
    referenceLineAttribute6?: string | null,
    referenceLineAttribute7?: string | null,
    referenceLineAttribute8?: string | null,
    creditMethodForAcctRule?: string | null,
    creditMethodForInstallments?: string | null,
    reasonCode?: string | null,
    taxRate?: string | null,
    taxCode?: string | null,
    taxPrecedence?: string | null,
    shipDateActual?: string | null,
    fobPoint?: string | null,
    shipVia?: string | null,
    waybillNumber?: string | null,
    invoicingRuleName?: string | null,
    accountRuleName?: string | null,
    accountingRuleDuration?: string | null,
    ruleStartDate?: string | null,
    primarySalesrepNumber?: string | null,
    salesOrder?: string | null,
    salesOrderLine?: string | null,
    salesOrderDate?: string | null,
    salesOrderSource?: string | null,
    salesOrderRevision?: string | null,
    agreementName?: string | null,
    memoLineName?: string | null,
    customerBankAccountName?: string | null,
    uomName?: string | null,
    taxExemptReasonCode?: string | null,
    taxExemptNumber?: string | null,
    headerAttribute1?: string | null,
    headerAttribute2?: string | null,
    headerAttribute3?: string | null,
    headerAttribute4?: string | null,
    headerAttribute5?: string | null,
    headerAttribute6?: string | null,
    headerAttribute7?: string | null,
    headerAttribute8?: string | null,
    headerAttribute9?: string | null,
    headerAttribute10?: string | null,
    headerAttribute11?: string | null,
    headerAttribute12?: string | null,
    headerAttribute13?: string | null,
    headerAttribute14?: string | null,
    headerAttribute15?: string | null,
    headerAttributeCategory?: string | null,
    comments?: string | null,
    globalAttributeCategory?: string | null,
    globalAttrbute1?: string | null,
    globalAttrbute2?: string | null,
    globalAttrbute3?: string | null,
    globalAttrbute4?: string | null,
    globalAttrbute5?: string | null,
    globalAttrbute6?: string | null,
    globalAttrbute7?: string | null,
    globalAttrbute8?: string | null,
    globalAttrbute9?: string | null,
    globalAttrbute10?: string | null,
    bankMessage?: string | null,

    draftInvoiceId?: string | null,
    customerId?: string | null,
    customerName?: string | null,
    customerAccountNumber?: string | null,
    transactionDate?: string | null,
    opType?: string | null,
    blNbr?: string | null,
    recordErrorCode?: string | null,
    performed?: string | null,
    transactionNumber?: string | null,
    saptAccountNumber?: string | null,
    branchCodeName?: string | null,
    collectionType?: string | null,
    receivedBy?: string | null,

    [key: string]: string | number | Date | null | undefined
}

export const EMPTY_INTERFACE_MONITORING_ENTITY: InterfaceMonitoringEntity = {
    id: 0,
    interfaceMonitorHdrId: null,
    messageType: "",
    status: null,
    sendReceiveDate: null,
    from: "",
    to: "",
    message: null,
    batchName: null,
    filename: null,
    setOfBooksId: null,
    accountingDate: null,
    currencyCode: null,
    dateCreated: null,
    createdBy: null,
    actualFlag: null,
    statusCCGLine: null,
    createdByCCGLine: null,
    userJeCategoryName: null,
    userJeSourceName: null,
    currencyConversionDate: null,
    userCurrencyConversionType: null,
    currencyConversionRate: null,
    enteredDr: null,
    enteredCr: null,
    accountedDr: null,
    accountedCr: null,
    reference1: null,
    reference2: null,
    reference4: null,
    reference5: null,
    reference6: null,
    reference7: null,
    reference8: null,
    reference10: null,
    segment1Pk: null,
    segment2Pk: null,
    segment3Pk: null,
    segment4Pk: null,
    segment5Pk: null,
    segment6Pk: null,
    segment7Pk: null,
    segment8Pk: null,
    segment9Pk: null,
    periodName: null,
    budgetVersionId: null,
    attribute1: null,
    attribute2: null,
    attribute3: null,
    attribute4: null,
    attribute5: null,
    attribute6: null,
    attribute7: null,
    attribute8: null,
    attribute9: null,
    attribute10: null,
    context: null,
    shippingLine: null,
    invoiceNo: null,
    invoiceDate: null,
    invoiceAmount: null,
    creditNoteNo: null,
    creditNoteDate: null,
    creditNoteAmount: null,
    receiptChequeNo: null,
    receiptChequeDate: null,
    receiptChequeAmount: null,
    taxChallenNo: null,
    taxChallenDate: null,
    taxChallenAmount: null,
    balanceAmount: null,
    remarks: null,
    interfaceDistributionId: null,
    interfaceLineId: null,
    interfaceLineContext: null,
    interfaceLineAttribute1: null,
    interfaceLineAttribute2: null,
    interfaceLineAttribute3: null,
    interfaceLineAttribute4: null,
    interfaceLineAttribute5: null,
    interfaceLineAttribute6: null,
    interfaceLineAttribute7: null,
    interfaceLineAttribute8: null,
    accountClass: null,
    amount: null,
    percent: null,
    segment1: null,
    segment2: null,
    segment3: null,
    segment4: null,
    segment5: null,
    segment6: null,
    segment7: null,
    segment8: null,
    segment9: null,
    docCreatedBy: null,
    docCreationDate: null,
    docLastUpdatedBy: null,
    docLastUpdateDate: null,
    orgId: null,
    attributeCategory: null,
    batchSourceName: null,
    lineType: null,
    description: null,
    custTrxTypeName: null,
    termName: null,
    origSystemBillCustomerRef: null,
    origSystemBillAddressRef: null,
    origSystemBillContactRef: null,
    origSystemShipCustomerRef: null,
    origSystemShipAddressRef: null,
    origSystemShipContactRef: null,
    origSystemSoldCustomerRef: null,
    linkToLineContext: null,
    linkToLineAttribute1: null,
    linkToLineAttribute2: null,
    linkToLineAttribute3: null,
    linkToLineAttribute4: null,
    linkToLineAttribute5: null,
    linkToLineAttribute6: null,
    linkToLineAttribute7: null,
    receiptMethodName: null,
    conversionType: null,
    conversionDate: null,
    conversionRate: null,
    trxDate: null,
    glDate: null,
    documentNumber: null,
    trxNumber: null,
    lineNumber: null,
    quantityOrdered: null,
    unitSellingPrice: null,
    referenceLineContext: null,
    referenceLineAttribute1: null,
    referenceLineAttribute2: null,
    referenceLineAttribute3: null,
    referenceLineAttribute4: null,
    referenceLineAttribute5: null,
    referenceLineAttribute6: null,
    referenceLineAttribute7: null,
    referenceLineAttribute8: null,
    creditMethodForAcctRule: null,
    creditMethodForInstallments: null,
    reasonCode: null,
    taxRate: null,
    taxCode: null,
    taxPrecedence: null,
    shipDateActual: null,
    fobPoint: null,
    shipVia: null,
    waybillNumber: null,
    invoicingRuleName: null,
    accountRuleName: null,
    accountingRuleDuration: null,
    ruleStartDate: null,
    primarySalesrepNumber: null,
    salesOrder: null,
    salesOrderLine: null,
    salesOrderDate: null,
    salesOrderSource: null,
    salesOrderRevision: null,
    agreementName: null,
    memoLineName: null,
    customerBankAccountName: null,
    uomName: null,
    taxExemptReasonCode: null,
    taxExemptNumber: null,
    headerAttribute1: null,
    headerAttribute2: null,
    headerAttribute3: null,
    headerAttribute4: null,
    headerAttribute5: null,
    headerAttribute6: null,
    headerAttribute7: null,
    headerAttribute8: null,
    headerAttribute9: null,
    headerAttribute10: null,
    headerAttribute11: null,
    headerAttribute12: null,
    headerAttribute13: null,
    headerAttribute14: null,
    headerAttribute15: null,
    headerAttributeCategory: null,
    comments: null,
    globalAttributeCategory: null,
    globalAttrbute1: null,
    globalAttrbute2: null,
    globalAttrbute3: null,
    globalAttrbute4: null,
    globalAttrbute5: null,
    globalAttrbute6: null,
    globalAttrbute7: null,
    globalAttrbute8: null,
    globalAttrbute9: null,
    globalAttrbute10: null,
    bankMessage: null,

    draftInvoiceId: null,
    customerId: null,
    customerName: null,
    customerAccountNumber: null,
    transactionDate: null,
    opType: null,
    blNbr: null,
    recordErrorCode: null,
    performed: null,
    transactionNumber: null,
    saptAccountNumber: null,
    branchCodeName: null,
    collectionType: null,
    receivedBy: null,

}

